import { ICommand, IDefineCommand, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IInterface, IInterfaceDTD } from 'utility-js-interface';
import { ORM } from 'utility-ts-orm';
import { PollAnswerDataStore } from '../datastore/poll_answer_datastore';
import { IPollBuilderDTD } from '../poll_interfaces';
import { PollResultsQueryModel } from '../queries/poll_results_query_model';
import { PollDataStore } from './../datastore/poll_datastore';
import { PollStudentDataStore } from './../datastore/poll_student_datastore';

angular
  .module('capability-ng-poll')
  .factory(
    'loadPollSummaryCommand',
    function updatePollStatusCommandDeinition(
      $q: ng.IQService,
      $http: ng.IHttpService,
      QueryMediator: IQueryMediator,
      ngPollDataStore: PollDataStore,
      defineCommand: IDefineCommand,
      ngPollStudentDataStore: PollStudentDataStore,
      ngPollAnswerDataStore: PollAnswerDataStore,
      ngPollResultsServant: any,
      ngPollResultsQueryModel: PollResultsQueryModel
    ): ICommand {
      return defineCommand(
        'loadPollSummaryCommand',
        function loadPollSummaryCommand(deferred: ng.IDeferred<any>, poll: IPollBuilderDTD): any {
          const answeredQuestions: string = _4
            .map(poll.answered_questions, (question: any) => {
              return question.questionID;
            })
            .join(',');

          $http.get(`poll/${poll.id}/totalanswers/?question_ids=${answeredQuestions}`).then((res: any) => {
            ngPollDataStore.addQuestionXChoice(_4.get(res, 'data.question_x_choice', {}));
            ngPollResultsQueryModel.run();
            deferred.resolve();
            ORM.run(ngPollDataStore, ngPollAnswerDataStore, ngPollStudentDataStore);
          });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-poll/src/commands/load_poll_summary.ts